import { render, staticRenderFns } from "./EgitimAnket.vue?vue&type=template&id=72a8fba5&"
import script from "./EgitimAnket.vue?vue&type=script&lang=js&"
export * from "./EgitimAnket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports